"use client";
import {
  BookOpen,
  CodeXml,
  FileText,
  History,
  KeyRound,
  MessagesSquare,
  Monitor,
  Network,
  Rocket,
  ShieldCheck,
  SlidersHorizontal,
  Sparkles,
  SquareDashed,
  TestTubeDiagonal,
} from "lucide-react";
import { NavSecondary } from "@/components/nav-secondary";
import { docsPages, docsHref } from "@/lib/docs/catalog";
import Github from "@/components/icons/github";
import NexumAPI from "@/components/icons/nexum-api";

import { useReferenceTree } from "./reference-tree";

const pageIcons: Record<string, typeof BookOpen> = {
  "": BookOpen,
  authentication: KeyRound,
  quickstart: Rocket,
  "mcp-quickstart": Network,
  "mcp-policies": ShieldCheck,
  "naas-endpoints": CodeXml,
  capabilities: Sparkles,
  changelog: History,
  "resources/symitar-playground": TestTubeDiagonal,
  "resources/credentials": SlidersHorizontal,
  "resources/device-information": Monitor,
  "resources/nil-field-support": SquareDashed,
  "help-and-feedback": MessagesSquare,
};

export function NexumNavigation() {
  const referenceTree = useReferenceTree();
  const groups = ["Getting started", "Resources", "SymXchange"].map(
    (group) => ({
      title: group,
      url: "/docs/nexum",
      pages: docsPages
        .filter((page) => page.product === "nexum" && page.group === group)
        .map((page) => ({
          title: page.title,
          url: docsHref(page.slug, page.product),
          exactMatch: true,
          icon: pageIcons[page.slug] ?? FileText,
        })),
    }),
  );
  return (
    <nav aria-label="NexumAPI documentation">
      <NavSecondary
        asLinks
        items={[
          groups[0],
          {
            title: "Links",
            url: "/docs/nexum",
            pages: [
              {
                title: "NexumAPI",
                url: "https://libum.io/nexum/",
                icon: NexumAPI,
              },
              {
                title: "Libum GitHub",
                url: "https://github.com/libum-llc",
                icon: Github,
                iconClassName: "!text-inherit",
              },
            ],
          },
          groups[1],
          {
            ...groups[2],
            pages: [
              {
                title: "API Reference",
                url: "/docs/nexum/symxchange/api-reference",
                exactMatch: false,
                icon: CodeXml,
                children: referenceTree,
              },
              ...groups[2].pages,
            ],
          },
        ]}
      />
    </nav>
  );
}
